import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import { OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Skeletons } from 'ui/components/skeleton';

import { DeliveryPlan } from 'services/action';

const initialState = {
  showDelete: false,
};

export const Action = ({ data, isLoading }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const [{ showDelete }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showDelete: false,
    }));
  };

  const $handleDelete = async () => {
    const req = await Dispatch(DeliveryPlan.$delete(data?.id));
    if (req?.message === 'success') {
      $handleClose();
      History.replace('/delivery/plan');
    }
  };

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const StandardAction = () => {
    return (
      data?.document_status === 'new' && (
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
          >
            <Link
              to={`/delivery/plan/${data?.id}/update`}
              className={cn('btn btn-primary px-2')}
            >
              <Fi.FiEdit size="17" />
            </Link>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
          >
            <button
              className={cn('btn btn-danger px-2')}
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  showDelete: true,
                }))
              }
            >
              <Fi.FiTrash2 size="17" />
            </button>
          </OverlayTrigger>
        </>
      )
    );
  };

  const FulfillmentAction = () => {
    return (
      <>
        {data?.fulfillment_status === 'unprocess' && (
          <>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Buat Fulfillment</Tooltip>}
            >
              <Link
                to={{
                  pathname: '/delivery/fulfillment/create',
                  state: { plan: data?.id },
                }}
                className={cn('btn btn-primary px-2 py-1')}
              >
                <Fi.FiEdit size="15" className='me-2' />
                Buat Fulfillment
              </Link>
            </OverlayTrigger>
          </>
        )}
      </>
    );
  };

  return (
    <div className="d-flex align-items-center gap-1 px-3 px-md-0 pb-2 pb-md-0">
      {isLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          <StandardAction />
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Print Surat Jalan</Tooltip>}
          >
            <Link
              to={`/print/fulfillment/${data?.id}`}
              className={cn('btn btn-info px-2')}
              target="_blank"
            >
              <Fi.FiPrinter size="17" />
            </Link>
          </OverlayTrigger>

          <FulfillmentAction />
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
